module.exports = __webpack_public_path__ + "static/media/29DUNON2.d6b55380.jpg";